import { render, staticRenderFns } from "./PoliticallyExposedModal.vue?vue&type=template&id=a141919a"
import script from "./PoliticallyExposedModal.vue?vue&type=script&lang=js"
export * from "./PoliticallyExposedModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports